import React from 'react'
import Typography from '@mui/material/Typography'
import { prop } from 'ramda'
import PropTypes from 'prop-types'
import List from '@mui/material/List'
import ListItem from '@mui/material/ListItem'

import { UploadedFilePlaceholder } from '~/components/FileUpload'

function UploadedFile ({ file, information }) {
  const areasCount = prop('areasCount', information)
  const locationsCount = prop('locationsCount', information)
  const warehousesCount = prop('warehousesCount', information)
  const zonesCount = prop('zonesCount', information)

  return (
    <UploadedFilePlaceholder file={file}>
      <Typography>
        You will be importing:
      </Typography>
      <List>
        <ListItem component={Typography}>{warehousesCount} warehouses</ListItem>
        <ListItem component={Typography}>{areasCount} areas</ListItem>
        <ListItem component={Typography}>{zonesCount} zones</ListItem>
        <ListItem component={Typography}>{locationsCount} locations</ListItem>
      </List>
    </UploadedFilePlaceholder>
  )
}

export default UploadedFile

UploadedFile.propTypes = {
  file: PropTypes.object,
  information: PropTypes.object
}
